document.querySelectorAll('.rs-card').forEach(card => {

  const select  = card.querySelector('.rs-variant');
  const input   = card.querySelector('.variant-id-input');
  const price   = card.querySelector('.rs-current-price');
  const compare = card.querySelector('.rs-compare-price');

  if (!select) return;

  /* NOTE: this function USED to also touch `.rs-btn` (innerText,
     disabled, sold-out class) on every variant switch. That's been
     removed — product-card-6.liquid's own 'change' listener on this
     exact same .rs-variant element already owns all button/stepper
     state (it knows whether this variant is already in the cart, is
     mid "Adding…" request, etc.). Having TWO independent listeners
     both mutate the same button caused real bugs: this one would
     unconditionally reset btn.disabled = false on every switch, which
     could re-enable the button mid-request and let a second
     /cart/add.js fire before the first one resolved.

     This function now ONLY does what product-card-6.liquid doesn't
     already do: sync the displayed price/compare-price for the newly
     selected variant. */
  function updatePriceDisplay() {

    const opt = select.selectedOptions[0];
    if (!opt) return;

    let p = parseInt(opt.dataset.price || 0);
    let c = parseInt(opt.dataset.compare || 0);

    /* PRICE UPDATE */
    if (price) {
      price.innerText = "₹" + (p / 100).toFixed(2);
    }

    /* COMPARE PRICE */
    if (compare) {
      if (c && c > p) {
        compare.innerText = "₹" + (c / 100).toFixed(2);
        compare.style.display = "inline";
      } else {
        compare.innerText = "";
        compare.style.display = "none";
      }
    }

    /* VARIANT SYNC — keep the hidden input in step with the select.
       Deliberately NOT touching card.dataset.cartLineKey / cartVariantId
       or the button/stepper here; product-card-6.liquid's own listener
       (registered on the same element) owns that reconciliation and
       runs alongside this one. */
    if (input) {
      input.value = select.value;
    }
  }

  select.addEventListener('change', updatePriceDisplay);

  // Initial load
  updatePriceDisplay();

});

/* ═══════════════════════════════════════════════════════════
   Rosier Collection Card — Discount % + Sale Highlight
   Targets MINIMOG THEME's actual rendered HTML classes.
   Safe to add to theme.liquid or a custom JS file.
   ═══════════════════════════════════════════════════════════ */

(function () {

  /* ── Read price value from Minimog price element ─────────
     Minimog renders prices as: ₹1,120.50
     We strip currency symbol + commas → parse as float      */
  function parsePrice(el) {
    if (!el) return 0;
    var txt = el.innerText || el.textContent || '';
    txt = txt.replace(/[₹,\s]/g, '').trim();
    return parseFloat(txt) || 0;
  }

  /* ── Format price back to ₹X,XXX.XX ─────────────────── */
  function formatPrice(num) {
    return '₹' + num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ── Inject discount + sale bar into a single card ─────── */
  function injectCard(card) {

    /* Already processed — skip */
    if (card.dataset.rsInjected) return;
    card.dataset.rsInjected = '1';

    var info = card.querySelector('.m-product-card__info, .rs-inner, [class*="product-card__info"]');
    if (!info) return;

    /* ── Create discount element ──────────────────────────── */
    var discountEl = document.createElement('div');
    discountEl.className = 'rs-discount';
    discountEl.style.cssText = 'color:green;font-size:14px;margin:2px 0 4px;min-height:0;';

    /* ── Create sale highlight bar ────────────────────────── */
    var saleBar = document.createElement('div');
    saleBar.className = 'rs-sale-highlight';
    saleBar.style.cssText = [
      'display:none',
      'align-items:center',
      'gap:6px',
      'margin:4px 0 4px',
      'background:linear-gradient(90deg,rgb(255 177 174) 0%,rgba(255,255,255,.21) 100%)',
      'padding:3px 5px',
      'border-radius:16px',
      'width:fit-content',
      'max-width:100%'
    ].join(';');

    var saleLabel = document.createElement('span');
    saleLabel.className = 'rs-sale-label';
    saleLabel.style.cssText = 'color:#9c1018;font-size:13px;font-weight:500;white-space:nowrap;';
    /* Label comes from data attribute set by Liquid on the card */
    saleLabel.innerText = card.dataset.saleLabel || 'Sale Price';

    var salePrice = document.createElement('strong');
    salePrice.className = 'rs-sale-price';
    salePrice.style.cssText = 'color:#9c1018;font-size:14px;font-weight:700;white-space:nowrap;';

    saleBar.appendChild(saleLabel);
    saleBar.appendChild(salePrice);

    /* ── Find where to insert: after .m-price block ─────── */
    var priceBlock = info.querySelector('.m-price, .rs-price, [class*="m-price"]');
    if (priceBlock) {
      priceBlock.after(discountEl);
      discountEl.after(saleBar);
    } else {
      info.appendChild(discountEl);
      info.appendChild(saleBar);
    }

    /* ── Update function ─────────────────────────────────── */
    function update() {

      /* Minimog puts current (sale) price in .m-price-item--sale
         and original in .m-price-item--regular inside .m-price__sale.
         For non-sale products: .m-price__regular .m-price-item--regular */

      var saleWrap   = info.querySelector('.m-price__sale');
      var regularWrap= info.querySelector('.m-price__regular');

      var currentPrice = 0;
      var comparePrice = 0;

      if (saleWrap && saleWrap.offsetParent !== null) {
        /* Product IS on sale */
        var saleEl    = saleWrap.querySelector('.m-price-item--sale, .m-price-item--last');
        var compareEl = saleWrap.querySelector('.m-price-item--regular');
        currentPrice  = parsePrice(saleEl);
        comparePrice  = parsePrice(compareEl);
      } else if (regularWrap) {
        /* Regular price — also check rs-current-price fallback */
        var regEl = regularWrap.querySelector('.m-price-item--regular, .m-price-item--last');
        currentPrice = parsePrice(regEl);
        /* Check rs-compare-price as fallback */
        var rsComp = info.querySelector('.rs-compare-price');
        if (rsComp) comparePrice = parsePrice(rsComp);
      }

      /* rs-current-price / rs-compare-price fallback (our snippet) */
      if (!currentPrice) {
        var rsCur = info.querySelector('.rs-current-price');
        if (rsCur) currentPrice = parsePrice(rsCur);
      }
      if (!comparePrice) {
        var rsComp2 = info.querySelector('.rs-compare-price');
        if (rsComp2) comparePrice = parsePrice(rsComp2);
      }

      /* ── Discount % ────────────────────────────────────── */
      if (comparePrice && comparePrice > currentPrice && currentPrice > 0) {
        var off = Math.round((comparePrice - currentPrice) * 100 / comparePrice);
        discountEl.innerText = '(' + off + '% OFF)';
      } else {
        discountEl.innerText = '';
      }

      /* ── Sale highlight bar ─────────────────────────────── */
      var showSaleBar = card.dataset.showSaleBar === 'true';
      if (showSaleBar && currentPrice > 0) {
        salePrice.innerText = formatPrice(currentPrice);
        saleBar.style.display = 'inline-flex';

        /* Hide Minimog's own current price, keep strikethrough */
        if (saleWrap) {
          var saleEl2 = saleWrap.querySelector('.m-price-item--sale, .m-price-item--last');
          if (saleEl2) saleEl2.style.visibility = 'hidden';
        }
        var rsCurEl = info.querySelector('.rs-current-price');
        if (rsCurEl) rsCurEl.style.display = 'none';

      } else {
        saleBar.style.display = 'none';
      }
    }

    update();

    /* ── Re-run on variant change (Minimog fires custom event) */
    card.addEventListener('on:variant:change', update);

    /* ── Also observe DOM changes in the price block ─────── */
    if (priceBlock) {
      new MutationObserver(update).observe(priceBlock, {
        childList: true, subtree: true, characterData: true
      });
    }
  }

  /* ── Process all cards on page load ─────────────────────── */
  function processAll() {
    document.querySelectorAll('.m-product-card').forEach(injectCard);
  }

  /* ── Also watch for lazy-loaded / paginated cards ────────── */
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.m-product-card')) injectCard(node);
        node.querySelectorAll && node.querySelectorAll('.m-product-card').forEach(injectCard);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAll);
  } else {
    processAll();
  }

})();